import React from 'react';

import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { NOT_FOUND } from 'src/assets';
import { useAppAuth } from 'src/hooks/auth';
import { SxProp } from 'src/types/mui';

export const NotFoundErrorPage: React.FC = () => {
  const { isAuthorized } = useAppAuth();

  const linkGoTo = isAuthorized ? appRoutes.inbox.index : appRoutes.auth.index;
  const textInBtn = isAuthorized ? 'Inbox' : 'Login';

  return (
    <Box textAlign="center" p={5} sx={notFoundStyles}>
      <img style={imgStyles} alt="Not found" src={NOT_FOUND} />

      <Typography variant="h5" sx={titleStyles}>
        Something missing
      </Typography>

      <Typography variant="body1" color="text.secondary" sx={descriptionStyles}>
        The page was not found. You may have mistyped the address or the page has moved to another
        location
      </Typography>

      <Button component={Link} size="large" variant="contained" to={linkGoTo}>
        Take me to {textInBtn}
      </Button>
    </Box>
  );
};

const imgStyles: React.CSSProperties = {
  width: '100%',
  maxWidth: '847px',
  marginBottom: '44px',
};

const notFoundStyles: SxProp = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};

const titleStyles: SxProp = theme => ({
  fontSize: '24px',

  [theme.breakpoints.up('md')]: {
    fontSize: '48px',
  },
});

const descriptionStyles: SxProp = {
  maxWidth: '412px',
  marginTop: '16px',
  marginBottom: '44px',
};
